import { Injectable } from '@angular/core';
import { take, tap } from 'rxjs/operators';
import { FilterService } from '../../interfaces/filter/filter-service';
import { OperationListStore } from './operation-list.store';
import { OperationListQuery } from './operation-list.query';
import { TableColumn } from '../../models/table-column';
import { LocalStoreConfigModel } from '../../models/local-store-config.model';
import { OperationListParams } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class OperationListService implements FilterService {
  constructor(
    private operationListStore: OperationListStore,
    private operationListQuery: OperationListQuery
  ) {}

  setFilter(params: OperationListParams) {
    this.operationListQuery.filterOptions$.pipe(take(1)).subscribe((values) => {
      params.operation = values.operation.selected;
      params.note = values.note.selected;
      params.costCenterName = values.costCenterName.selected;
      params.costCenterNumber = values.costCenterNumber.selected;
      params.filterAll =
        !values.operation.selected &&
        !values.costCenterName.selected &&
        !values.costCenterNumber.selected &&
        !values.note.selected;
    });
    return params;
  }

  clearFilterValue() {
    this.operationListStore.update((state) => ({
      ...state,
      filterValue: '',
    }));
  }

  filterValueChange(filterValue: string) {
    this.operationListStore.update((state) => ({
      ...state,
      filterValue,
    }));
  }

  setFilterOptions(
    filterSelection: any,
    storeConfig?: LocalStoreConfigModel
  ): void {
    this.operationListStore.update((state) => ({
      ...state,
      filterOptions: filterSelection,
    }));
  }

  /**
   * Set new Selected Columns.
   *
   * @param columns New selection of columns.
   */
  showSelectedColumns(columns: TableColumn[]): void {
    this.operationListStore.update((state) => ({
      ...state,
      columns,
    }));
  }
}
